import PropTypes from 'prop-types';
import YouTube from 'react-youtube';

import styles from './VideoESpot.module.scss';

const PLAYER = {
  DEFAULT: {
    width: 560,
    height: 315
  },
  SMALL: {
    width: 320,
    height: 180
  }
};

export const VideoESpot = ({
  data,
  lang,
  withAutoplay = false,
  withLogo = false,
  isSmall = false,
  isInCarousel = false
}) => {
  const options = {
    ...PLAYER.DEFAULT,
    playerVars: {
      autoplay: +withAutoplay,
      modestbranding: +!withLogo,
      rel: 0, // Related videos will come from the same channel as the video that was just played
      hl: lang
    },
  };
  const smallClassName = isSmall ? 'small' : '';

  if (isSmall) {
    options.height = PLAYER.SMALL.height;
    options.width = PLAYER.SMALL.width;
  }

  return data ? (
    isInCarousel ? (
      <div className={styles.container}>
        <div className={styles.video}>
          <YouTube
            videoId={data.idYoutube}
            iframeClassName="video-container"
            opts={options}
          />
        </div>
      </div>
    ) : (
      <div height={options.height} width={options.width}>
        <div className={`full-background-video ${smallClassName}`}>
          <div className={`video ${smallClassName}`}>
            <YouTube
              videoId={data.idYoutube}
              iframeClassName="video-container"
              opts={options}
            />
          </div>
        </div>
      </div>
    )
  ) : null;
};

VideoESpot.propTypes = {
  lang: PropTypes.string.isRequired,
  data: PropTypes.shape({
    idYoutube: PropTypes.string.isRequired,
  }).isRequired,
  withAutoplay: PropTypes.bool,
  withLogo: PropTypes.bool,
  isSmall: PropTypes.bool,
  isInCarousel: PropTypes.bool
};

export default VideoESpot;
